import ComponentGuard from '@/components/ui/custom/ComponentGuard';
import { UserTypeEnum } from '@/models/User';
import ProjectCarouselFetcher from '../projects/carousel/ProjectCarouselFetcher';
import useListService from '@/data/hook/useListService';
import { hackathonsQueryKeys } from '@/data/services/querykeys';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { Skeleton } from '../ui/daisy';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { LEI_FELCA } from '@/lib/growthbook';

type Props = {
  userId: number;
};

export default function ProfileProjects({ userId }: Props) {
  const isLeiFelca = useFeatureIsOn(LEI_FELCA);
  const { results: hackathons, isInitialLoading: isLoadingHackathons } =
    useListService({
      ...hackathonsQueryKeys.list(),
      staleTime: REQUEST_STALE_TIME_IN_MS,
      enabled: isLeiFelca,
    });

  if (isLeiFelca && isLoadingHackathons) {
    return <Skeleton className="w-full h-72" />;
  }

  const flagsIds = hackathons.map(hackathon => hackathon.flagId);

  if (!flagsIds.length && isLeiFelca) return null;

  return (
    <ComponentGuard roles={[UserTypeEnum.STUDENT]}>
      <ProjectCarouselFetcher
        section="me"
        filters={{
          user: userId,
          ...(isLeiFelca && { flagsId: flagsIds }),
        }}
        hideSeeAll
      />
    </ComponentGuard>
  );
}
